

<template>
  <br>
  <p class="fw-bold">   </p>

  <div class="d-flex  mb-2 w-100 justify-content-evenly" >
    <div class="  d-flex flex-column">
      <label class="text-end required">کد</label>
      <input v-model="code" type="text" class="form-control">
    </div>
    <div class="  d-flex flex-column">
      <label class="text-end required">عنوان پیامد فوری</label>
        <textarea v-model="title" class="form-control" cols="20" rows="30"></textarea>
    </div>

    <div class="  d-flex flex-column">
      <label class="text-end required">مالک پیامد فوری  </label>
      <input placeholder="انتخاب کنید" v-model="owner" type="text" class="form-control" readonly @click.prevent="showListOrganization">
    </div>
    <div class="  d-flex flex-column">
      <label class="text-end required">ستانده  </label>
      <input :placeholder="'انتخاب کنید'" v-model="outputName" type="text" class="form-control" readonly  @click.prevent="showListOutput">
    </div>
    <div class="  d-flex flex-column">
      <label class="text-end required">نماگر اندازه‌گیری  </label>
        <textarea v-model="MeasurementChart" class="form-control" cols="20" rows="30"></textarea>
    </div>
    <div class="  d-flex flex-column">
      <label class="text-end required">واحد سنجش نماگر  </label>
        <textarea v-model="GraphMeasuringUnit" class="form-control" cols="20" rows="30"></textarea>
    </div>
    <button v-if="!is_update" @click.prevent="submitForm" style="margin-top: 1.3vw;" class="btn btn-primary btn-submit-1">ثبت</button>
    <button v-else @click.prevent="update(id)" style="margin-top: 1.3vw;" class="btn btn-primary btn-submit-1">ویرایش</button>  </div>
  <center>
    <hr style="width: 70vw; margin: 1vw 0;">
    <p v-show="!items.length">
      پیامد فوری یافت نشد
    </p>
    <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">

    <table v-show="items.length"  class="table table-striped" style="width: 70vw;" >
      <thead>
      <tr>
        <th style="width: 1vw;"> ردیف</th>
        <th>کد  </th>
        <th>عنوان  </th>
        <th>پست سازمانی  </th>
        <th>ستانده    </th>
        <th>نماگر اندازه گیری   </th>
        <th>واحد سنجش شاخص    </th>
        <th style="width: 8vw;">عملیات</th>
      </tr>
      </thead>
      <tbody>
      <tr  v-for="(item, index) in items">
        <td scope="row" style=" font-size: 1vw">{{index+1}}</td>
        <td>{{item.code}}</td>
        <td>{{item.title}}</td>
        <td>{{item.organizationpost.name}}</td>
        <td >
        <div style="height: 1vw; transform: translateY(1vw)" class="d-flex align-items-center justify-content-center">
          <p class="btn-submit-1 btn btn-primary" @click.prevent="showAllList(item.id)" >مشاهده</p>
        </div>
        </td>
        <td>{{item.measurement_chart }}</td>
        <td>{{item.graph_measuring_unit}}</td>





        <td>
          <a @click.prevent="edit(item['id'])" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>
          <a @click.prevent="deleteItemModal(item.id) " href="#"><img class="table-delete-img mx-2"  src="/img/delete.f9fc94bc.svg" alt="delete"></a>
        </td>
      </tr>

      </tbody>
    </table>
    </div>
  </center>

  <div dir="rtl" class="modal__error slide-top" v-show="select_organization"
       style="z-index: 999999999999999999999999999999999999999999999; top: 16%;">
    <div>
      <p>مالک پیامد فوری    </p>
      <p @click="select_organization=!select_organization">❌</p>
    </div>
    <div>
      <input style="width: 20vw;" v-model="search_organization" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس پست سازمانی...">
      <div style="overflow-y: scroll; width: 100%; height: 10vw;" :style="filteredorganization.length < 5 ? 'height: auto;' : ''">

      <table class="table ">
        <thead>
        <tr>
          <th style="width: 1vw !important;">انتخاب</th>
          <th>پست سازمانی</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredorganization" :key="item.id">
          <td style="width: 1vw !important;" ><input v-model="organizationId" type="radio" name="parent" :value="item['id']"></td>
          <td style="width: 27vw;">{{ item['name'] }}</td>
        </tr>

        </tbody>
      </table>
    </div>
      <button @click="select_organizationMethod">تایید</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="select_output"
       style="z-index: 999999999999999999999999999999999999999999999; top: 25%;">
    <div>
      <p> ستانده    </p>
      <p @click="select_output=!select_output">❌</p>
    </div>
    <div>
      <input style="width: 20vw;" v-model="search_output" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و عنوان  ...">
      <div style="overflow-y: scroll; height: 18vw;" :style="filteredOutputs.length < 5 ? 'height: auto;' : ''">

      <table class="table table-striped">
        <thead>
        <tr>
          <th style="width: 1vw !important;">انتخاب</th>
          <th>فرآیند</th>
          <th>عنوان      </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredOutputs" :key="item.id">
          <td style="width: 1vw;" scope="row"><input v-model="outputId"
                                                     type="checkbox"    :value="item['id']"></td>
          <td style="width: 8vw;">{{ item['process'] && item['process']['title'] }}</td>
          <td style="width: 8vw;">{{ item['title'] }}</td>
        </tr>

        </tbody>
      </table>


    </div>
      <center>
        <button class="btn btn-primary btn-submit-1 mt-3" @click="select_outputMethod">تایید</button>

      </center>
    </div>
  </div>

  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="select_outputother"
       style="z-index: 999999999999999999999999999999999999999999999; top: 4%;">
    <div>
      <p> ستانده    </p>
      <p @click="select_outputother=!select_outputother">❌</p>
    </div>
    <div>
      <div style="overflow-y: scroll; height: 50vw; width: 100%;" :style="allOthers.length < 5 ? 'height: auto;' : ''">


      <table class="table table-striped">
        <thead>
        <tr>
          <th>ردیف</th>
          <th>عنوان      </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in allOthers" :key="item.id">
          <td>{{ index+1 }}</td>
          <td>{{ item['name'] }}</td>
        </tr>

        </tbody>
      </table>
    </div>
      <button class="btn btn-primary btn-submit-1" @click="select_outputother=!select_outputother">بازگشت</button>
    </div>
  </div>

</template>
<script  >
import login from "@/views/auth/Login.vue";

export  default {
  data(){
    return{
      all_outputs: [],
      all_organization: [],
      allOthers: [],
      items: [],
      code: '',
      title: '',
      owner: '',
      received: '',
      MeasurementChart: '',
      GraphMeasuringUnit: '',
      id: '',
      outputId: [],
      outputName: '',
      organizationId: '',
      search_organization: '',
      search_output: '',
      select_organization: false,
      select_output: false,
      is_update: false,
      deleteModal: false,
      select_outputother: false,

    }
  },
  methods:{
    showAllList(id){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      this.allOthers.length=0


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/graph_measuring_unit/all_by_id/parents/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response){
               response.items.forEach((item)=>{
                 this.allOthers.push(item)
               })
              this.select_outputother =true

            }



          })
          .catch();
    },showAllList2(id){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      this.allOthers.length=0


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/graph_measuring_unit/all_by_id/parents/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response){
               response.items.forEach((item)=>{
                 this.outputId.push(item.id)
               })


            }



          })
          .catch();
    },
    deleteItemModal(id){
      this.id=id
      this.deleteModal=true

    },
    edit(id){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      formdata.append('code', this.code)
      formdata.append('title', this.title)
      formdata.append('process_id', this.inserterId)
      formdata.append('monitoring_process_id', this.unit_id)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/graph_measuring_unit/show/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response){
              this.code = response.item.code
              this.title = response.item.title
              this.owner = response.item.organizationpost.name
              this.organizationId = response.item.organizationpost.id

              this.MeasurementChart = response.item.measurement_chart
              this.GraphMeasuringUnit = response.item.graph_measuring_unit
              this.is_update=true
              this.id = response.item.id

            }



          })
          .catch();
    },
    update(id){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      formdata.append('owner_id', this.organizationId)
      formdata.append('definition_of_outputs_id', JSON.stringify(this.outputId))
      formdata.append('code', this.code)
      formdata.append('title', this.title)
      formdata.append('measurement_chart', this.MeasurementChart)
      formdata.append('graph_measuring_unit', this.GraphMeasuringUnit)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/graph_measuring_unit/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response){
              this.code = ''
              this.title = ''
              this.owner = ''
              this.organizationId = ''
              this.outputId.length=0
              this.outputName = ''
              this.MeasurementChart = ''
              this.GraphMeasuringUnit = ''
              this.id = ''

              this.allItems()
              this.is_update=false
              this.id=''
            }



          })
          .catch();
    },
    deleteItemForm(id){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      formdata.append('code', this.code)
      formdata.append('title', this.title)
      formdata.append('process_id', this.inserterId)
      formdata.append('monitoring_process_id', this.unit_id)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/graph_measuring_unit/delete/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response){

              this.deleteModal=false
              this.id=''
              this.allItems()
            }



          })
          .catch();
    },
    submitForm(){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      formdata.append('owner_id', this.organizationId)
      formdata.append('definition_of_outputs_id', JSON.stringify(this.outputId))
      formdata.append('code', this.code)
      formdata.append('title', this.title)
      formdata.append('measurement_chart', this.MeasurementChart)
      formdata.append('graph_measuring_unit', this.GraphMeasuringUnit)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/graph_measuring_unit/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response){
              this.code = ''
              this.title = ''
              this.owner = ''
              this.organizationId = ''
              this.outputId.length = 0
              this.outputName = ''
              this.MeasurementChart = ''
              this.GraphMeasuringUnit = ''

              this.allItems()
            }



          })
          .catch();
    },
    allItems(){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      formdata.append('code', this.code)
      formdata.append('title', this.title)
      formdata.append('process_id', this.inserterId)
      formdata.append('monitoring_process_id', this.unit_id)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/graph_measuring_unit/all`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.items){
              this.items.length=0
              response.items.forEach((item)=>{
                this.items.push(item)
              })
            }



          })
          .catch();
    },
    select_organizationMethod() {
      this.all_organization.forEach((ele) => {
        ele.id === this.organizationId ? this.owner = ele.name : ''
      })
      this.select_organization = false


    },
    showListOrganization() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/organization/post/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.all_organization.length = 0

            if (result['all'].length !== 0) {
              result['all'].forEach(item => {
                this.all_organization.push(item)

              })
              this.select_organization = true

            }

          })
          .catch();
    },
    select_outputMethod() {
      this.all_outputs.forEach((ele) => {
        console.log(ele)
        parseInt(ele.id) === parseInt(this.outputId) ? this.outputName = ele.title : ''
      })
      this.select_output = false


    },
    showListOutput() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/definition_of_output/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.all_outputs.length = 0

            if (result['items'].length !== 0) {
              result['items'].forEach(item => {
                this.all_outputs.push(item)

              })
              this.select_output = true

            }

          })
          .catch();
    },


  },
  computed:{
    login() {
      return login
    },
    filteredorganization() {
      return this.all_organization.filter(item => {
        return (
            item['name'].includes(this.search_organization) ||
            item['id'].toString().includes(this.search_organization)
        );
      });
    },
    filteredOutputs() {
      return this.all_outputs.filter(item => {
        return (
            item['title'].includes(this.search_output) ||
            item['code'].toString().includes(this.search_output)
        );
      });
    },
  },
  mounted() {
    this.allItems()
  }
}

</script>
<style scoped>
label{
  font-size: .8vw;
}
input{
  width: 8vw;
}
</style>